import styles from './LoyaltyInfo.module.css';
import Card from '../Card/index.jsx';
import LevelIcon from '@/shared/ui/LevelIcon/index.jsx';
import { pluralize } from '@/shared/lib/pluralize/pluralize.js';
import { LEVEL_NAME } from '../../model/const.js';

export default function LoyaltyInfo({ user }) {
    return (
        <section className={`container-custom ${styles.loyalty}`}>
            <p className={`section-title ${styles.secTitle}`}>Система лояльности</p>

            {/* текстовый баннер */}
            <div className={`row g-0 ${styles.cards}`}>
                <div className={styles.invisibleCard} />
                <div className={styles.invisibleCard}>
                    <p className="body">
                        Каждое приключение в "Подземелье" - это шаг к новым возможностям.
                        Мы ценим твою преданность и возвращаем её в игре: участвуя в сессиях,
                        ты накапливаешь баллы, которые можно использовать для частичной оплаты
                        будущих игр. Это простой и честный способ поощрить тех, кто с нами снова и снова.
                        Чем чаще играешь, тем легче попасть в следующее приключение.
                    </p>
                </div>
                <div className={styles.invisibleCard}>
                    <div className="body">
                        Уровни системы лояльности
                        <ul>
                            <li>Бронзовый: посети 2-10 игр, накапливай 3% от стоимости игры;</li>
                            <li>Серебрянный: посети 11-25 игр, накапливай 5% от стоимости игры;</li>
                            <li>Золотой : посети 25-50 игр, накапливай 7% от стоимости игры;</li>
                            <li>Платиновый: посети 51-100 игр, накапливай 10% от стоимости игры.</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* четыре карточки */}
            <div className={`row ${styles.cards}`}>
                <Card
                    title="Ваш уровень"
                    value={<LevelIcon level={user?.userLevel} className={styles.level} />}
                    subtitle={LEVEL_NAME[user?.userLevel] || 'Не установлено'}
                />
                <Card
                    title="У вас на счёте"
                    value={parseInt(user?.countPoints)}
                    subtitle={pluralize(user?.countPoints ?? 0, ['балл', 'балла', 'баллов'])}
                />
                <Card
                    title="Вы накапливаете"
                    value={`${user?.accumulationPercentage}%`}
                    subtitle="от стоимости игры"
                />
                <Card
                    title="Осталось"
                    value={user?.countGamesToNextLevel}
                    subtitle={`${pluralize(user?.countGamesToNextLevel ?? 0, ['игра', 'игры', 'игр'])} до уровня`}
                />
            </div>
        </section>
    );
}
